import { Line } from 'react-chartjs-2';

import { Block } from '@attom';

import CS from './ExchangeRateChart.module.scss';

export const ExchangeRateChart = ({
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	//
	width = null,
	height = null,
	//
	history = [],
	labelProperty = 'PERSIANPERIOD',
	dataProperty = 'MAXBUYPRICE',
}) => {
	const data = (canvas) => {
		const ctx = canvas.getContext('2d');
		let height = ctx.canvas.height;
		const gradient = ctx.createLinearGradient(0, 0, 0, height - height / 4);
		gradient.addColorStop(0, `rgba(5, 184 ,212, .12)`);
		gradient.addColorStop(1, `rgba(5, 184 ,212, .01)`);

		return {
			labels: history.map((item) => item[labelProperty].replaceAll('-', '/')).reverse(),
			datasets: [
				{
					label: '',
					data: history.map((item) => item[dataProperty]),
					borderColor: '#048A9F',
					borderWidth: 1,
					pointBorderWidth: 2,
					pointBorderColor: '#05B8D4',
					pointBackgroundColor: '#05B8D4',
					fill: true,
					backgroundColor: gradient,
					tension: 0.05,
				},
			],
		};
	};

	const options = {
		locale: new Intl.NumberFormat('fa-IR', { style: 'currency', currency: 'IRR' }),
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				rtl: true,
				backgroundColor: 'rgba(4, 138, 159, .7)',
				displayColors: false,
				//
				titleColor: 'rgba(255, 255, 255, .9)',
				titleAlign: 'center',
				titleFont: {
					family: 'iranYekan',
				},
				//
				bodyColor: 'rgba(255, 255, 255, .9)',
				bodyAlign: 'center',
				bodyFont: {
					family: 'iranYekan',
				},
				//
				callbacks: {
					title: (e) => `تاریخ: ${e[0].label}`,
					label: (e) => `${e.formattedValue} ریال`,
				},
			},
		},
		scales: {
			y: {
				beginAtZero: false,
				ticks: {
					display: true,
					color: '#323232',
					font: {
						family: 'iranYekan',
					},
					callback: (value, i, values) => `${value} ریال`,
				},
				grid: {
					// display: false,
				},
			},
			x: {
				ticks: {
					display: true,
					font: {
						family: 'iranYekan',
					},
				},
				grid: {
					// display: false,
				},
			},
		},
	};

	return (
		<Block boxClass={`${boxClass} ${CS.container}`} boxSize={boxSize} boxSpace={boxSpace}>
			<Line data={data} options={options} width={width} height={height} className={CS.container} />
		</Block>
	);
};
